import { HTMLAttributes } from 'react';
import { Theme, styled } from '@mui/material';

export type ContainerProps = {
  ['margin-v']?: 'small' | 'medium' | 'large' | 'auto';
  ['margin-h']?: 'small' | 'medium' | 'large' | 'auto';
  ['text-align']?: 'left' | 'right' | 'center' | 'justify';
} & HTMLAttributes<HTMLDivElement>;

const getMargin = (theme: Theme, p: 'small' | 'medium' | 'large' | 'auto') => {
  switch (p) {
    case 'small':
      return theme.spacing(2.5);

    case 'medium':
      return theme.spacing(5);

    case 'large':
      return theme.spacing(10);
  
    case 'auto':
      return 'auto';
  }
};

const Container: any = styled('div')<ContainerProps>(({ theme, ...props }) => ({
  ...(props['margin-v'] && {
    marginTop: getMargin(theme, props['margin-v']),
    marginBottom: getMargin(theme, props['margin-v']),
  }),
  ...(props['margin-h'] && {
    marginLeft: getMargin(theme, props['margin-h']),
    marginRight: getMargin(theme, props['margin-h']),
  }),
  ...(props['text-align'] && {
    textAlign: props['text-align']
  }),
}));

export default Container;